import { render, staticRenderFns } from "./messageTemplateUpdatePanel.vue?vue&type=template&id=7b2925c4&scoped=true&"
import script from "./messageTemplateUpdatePanel.vue?vue&type=script&lang=js&"
export * from "./messageTemplateUpdatePanel.vue?vue&type=script&lang=js&"
import style0 from "./messageTemplateUpdatePanel.vue?vue&type=style&index=0&id=7b2925c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2925c4",
  null
  
)

export default component.exports